document.addEventListener("DOMContentLoaded", () => {
  console.log("%c[Mobile Drawer]", "background:#000;color:#fff;", "Init");

  // A product with no subscription may render no Loop widget at all, so this
  // gives up after a few seconds and carries on with whatever is there - the
  // drawer is still the only way to buy on mobile.
  const waitForLoopWidget = (cb) => {
    const started = Date.now();

    const intv = setInterval(() => {
      const loop = document.querySelector(".loop-widget-container");
      const ready = loop && loop.querySelectorAll(".loop-widget-purchase-option").length > 0;

      if (!ready && Date.now() - started < 4000) return;

      clearInterval(intv);
      cb(loop);
    }, 250);
  };

  waitForLoopWidget((loopContainer) => {
    const productType = window.productPurchaseType || "Single";
    //const mainForm = document.querySelector("form[action='/cart/add']");
    const mainForm = Array.from(document.querySelectorAll("form[action='/cart/add']")).find(form => form.offsetParent !== null);
    if (!mainForm) return;

    /* ProductOptions.connectedCallback does, with no null check:
         this.section_root = this.closest("[data-section-id]");
         this.section_id   = this.section_root.getAttribute("data-section-id");
       The drawer hangs off document.body, outside every section, so once the
       form is borrowed that closest() returns null and the callback throws -
       taking every listener wired after it in the same move with it. The host
       carries the real section id so the borrowed form still resolves one, and
       any element that does re-initialise in there refetches the right section. */
    const sectionId = mainForm.closest("[data-section-id]")?.getAttribute("data-section-id");

    // --- DOM Elements ---
    /* Scoped to the mobile gallery: unscoped this matched the DESKTOP gallery's
       first media, because main-product.liquid renders desktop first. Falls back
       to the old query on any layout that has no mobile wrapper. */
    const imgEl = document.querySelector('.main-product--mobile:not([data-type]) .product-media--container .product-media--root img')
      || document.querySelector(".product-media--container .product-media--root img");
    const imgElo = document.querySelector('.main-product--mobile[data-type="optional"] .product-media--container .product-media--root img');
    const titleEl = document.querySelector(".product-form--block--heading");
    const iconsEl = document.querySelector(".product-icons");
    const productBannerEL = document.querySelector(".product-banner");

    let subDesc = "";
    let oneTimeDesc = "";

    if (productType === "Single") {
      // For single SKU
      subDesc = `<ul class="loop-desc">
          <li>buy 5+ to subscribe</li>
          <li>save 10% off every month</li>
          <li>skip, pause, or cancel anytime</li>
        </ul>
        <div class="desc-bottom">Subscription requires a minimum of 5 masks per order.</div>
        `;
      oneTimeDesc = ""; // optional – no one-time description for singles
    }

    else if (productType === "Starter Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>2 hydrogel facial masks shipped monthly</li>
          <li>3 everyday facial sheet masks shipped monthly</li>
          <li><b>free</b> rini headband one-time shipment</li>
          <li>pause, cancel, or adjust at anytime</li>
        </ul>`;
      oneTimeDesc = `<ul class="loop-desc">
          <li>2 hydrogel facial masks</li>
          <li>3 everyday facial sheet masks</li>
          <li class="no">no free headband</li>
        </ul>`;
    }

    else if (productType === "Bundle") {
      subDesc = `<ul class="loop-desc">
          <li>save 10% off every month</li>
          <li>skip, pause, or cancel anytime</li>
        </ul>`;
      oneTimeDesc = ``;
    }

    else if (productType === "Bundle with subscription only") {
      subDesc = ``;
      oneTimeDesc = "";
    }

    // Every product type gets the same drawer now: one "shop now" button that
    // opens the real product form. See the borrowed-form block further down.
    // Kept as a named flag so it stays easy to scope back per product type -
    // the two-mode ghost-button path below is intact, just unused while true.
    const borrowsForm = true;

    
    //const oneTimePrice = loopContainer.querySelector(".loop-widget-purchase-option-onetime .loop-widget-purchase-option-price-container");
    const oneTimePrice = document.querySelector(".product-price--wrapper");
    const subPrice = loopContainer?.querySelector("[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price-container");

    const realQty = mainForm.querySelector('input[name="quantity"]');
    const realSubmit = mainForm.querySelector('button[type="submit"]');
    const oneTimeOption = loopContainer?.querySelector(".loop-widget-purchase-option-onetime");
    const subOption = loopContainer?.querySelector("[data-loop-widget-selling-plan-group]");

    // No selling-plan group means the product cannot be subscribed to. It gets
    // the same drawer as everything else - the only difference is that the
    // header keeps its price, since there are no option rows quoting one.
    const hasSubscription = !!subOption;
    // Loop's real delivery-frequency selector (lives inside the subscription option).
    // We move this live node into the drawer so its own handlers keep updating selling_plan.
    let freqSelector = subOption ? subOption.querySelector(".loop-widget-spg-container") : null;
    const freqOriginalParent = freqSelector ? freqSelector.parentNode : null;
    const isOutOfStock = realSubmit && realSubmit.disabled;
    const footer = document.querySelector(".layout--footer-group");


    



    // --- Overlay (bound to body) ---
    let overlay = document.querySelector("#drawer-overlay-global");
    if (!overlay) {
      overlay = document.createElement("div");
      overlay.id = "drawer-overlay-global";
      document.body.appendChild(overlay);
    }

    // --- Drawer ---
    const drawer = document.createElement("div");
    drawer.className = "mobile-drawer collapsed";
    drawer.innerHTML = `
      <div class="drawer-inner">
        <div class="drawer-header">
          <div class="drawer-info">
            <img class="drawer-main-image" src="${imgEl?.src || ""}" alt="">
            ${imgElo ? `<img class="drawer-optional-image" style="display:none" src="${imgElo?.src || ""}" alt="">` : ""}
            <div class="drawer-title">
              <div>
                  <div>${titleEl?.innerHTML || ""}</div>
                  <span class="drawer-badge" style="border-radius: 30px; background: rgb(237, 249, 179); padding: 2px 7px; font-weight: 500; display:none; margin-right:auto; margin-top:5px">33% off</span>
              </div>
              <div class="drawer-price">${oneTimePrice?.outerHTML || ""}</div>
            </div>
          </div>
          <button class="drawer-close">×</button>
        </div>

        <div class="drawer-widget" style="display:none"></div>

        <div class="drawer-features"></div>

        <div class="drawer-frequency" style="display:none"></div>

        <div class="drawer-qty">
          <button class="minus">−</button>
          <input type="text" value="${realQty?.value || 1}" readonly>
          <button class="plus">+</button>
        </div>

        <div class="drawer-actions">
          ${
            isOutOfStock
              ? `<button class="ghost-btn outofstock" disabled>Out of stock</button>`
              : borrowsForm
                ? `<button class="ghost-btn shopnow">Shop now</button>`
                : `
                <button class="ghost-btn onetime">Buy one-time</button>
                <button class="ghost-btn subscribe">Subscribe • Save 10%</button>
              `
          }
        </div>
        <div class="drawer-terms"></div>
        <div class="drawer-freegift" style="display:none">
          <div class="product-banner">
            <div class="text">
              You've unlocked <br/> a free rini headband!
            </div>
            <div class="image">
              <img src="https://cdn.shopify.com/s/files/1/0893/2746/8728/files/freeheadband.png?v=1763036838" width="auto" height="auto" />
            </div>
          </div>
        </div>
        <div class="drawer-bottom">${iconsEl?.outerHTML || ""}</div>
      </div>
    `;
    document.body.appendChild(drawer);

    const actionTerms = drawer.querySelector(".drawer-terms");
    const waitForPaymentTerms = setInterval(() => {
      const el = document.querySelector('shopify-payment-terms');
      if (el) {
        clearInterval(waitForPaymentTerms);
        actionTerms.innerHTML = el.outerHTML;
      }
    }, 300);

    // --- Scroll hide/show ---
    let lastScrollTime = 0;
    let hideTimeout;

    window.addEventListener("scroll", () => {
      if (window.innerWidth > 767) return;

      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const windowHeight = window.innerHeight;

      // Hide if near or overlapping footer
      if (footerTop < windowHeight + 40) {
        drawer.classList.add("hide");
        return;
      }

      // Skip hiding if expanded
      if (drawer.classList.contains("expanded")) return;

      drawer.classList.add("hide");
      lastScrollTime = Date.now();

      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        if (Date.now() - lastScrollTime >= 200) drawer.classList.remove("hide");
      }, 250);
    });

    const qtyInput = drawer.querySelector("input");
    const plusBtn = drawer.querySelector(".plus");
    const minusBtn = drawer.querySelector(".minus");
    const oneTimeBtn = drawer.querySelector(".onetime");
    const subBtn = drawer.querySelector(".subscribe");
    const closeBtn = drawer.querySelector(".drawer-close");
    const features = drawer.querySelector(".drawer-features");
    const freqContainer = drawer.querySelector(".drawer-frequency");
    const priceDisplay = drawer.querySelector(".drawer-price");
    const actionWrapper = drawer.querySelector(".drawer-actions");
    const freegift = drawer.querySelector(".drawer-freegift");
    const drawerBadge = drawer.querySelector(".drawer-badge");
    const drawerImage = drawer.querySelector(".drawer-main-image");
    const drawerImageOpt = drawer.querySelector(".drawer-optional-image");
    const widgetHost = drawer.querySelector(".drawer-widget");
    if (sectionId) widgetHost.setAttribute("data-section-id", sectionId);

    /* The header image is seeded once above and nothing else ever reassigns it,
       so the Travel/Standard dropdown in loop-custom-logics.js has to tell us.
       It waits on the Loop widget too and either of us can win that race, hence
       the replay value as well as the event. */
    function setHeroImage(src) {
      if (src && drawerImage && drawerImage.src !== src) drawerImage.src = src;
    }

    setHeroImage(window.__riniHeroSrc);
    window.addEventListener("rini:hero-image", event => setHeroImage(event.detail && event.detail.src));

    if (borrowsForm) drawer.classList.add("drawer--borrowed-form");
    if (!hasSubscription) drawer.classList.add("drawer--no-subscription");

    /* -------------------------------
      BORROWED PRODUCT FORM

      The design is the product form itself - Loop's own purchase
      option rows, gift cards and frequency selector, then the theme's qty +
      add-to-cart. So the drawer borrows the live <form> rather than restating
      any of it, and hands it back on close.

      It has to be the whole form, not just the blocks that show: the selling
      plan, variant id and quantity are form-associated inputs, and anything
      lifted out of the form stops being submitted. CSS hides the blocks that
      shouldn't appear - see .drawer--borrowed-form in the stylesheet.
    --------------------------------*/
    const formOrigin = { parent: mainForm.parentNode, next: mainForm.nextSibling };

    /* Moving a node re-runs every custom element's connectedCallback, and the
       theme's elements bind their listeners there with no disconnectedCallback
       to unbind. QuantitySelector is the visible one: plusListener() does
       this.plus.on("click keydown", ...) on every connect, so after the borrow
       two handlers were live and one "+" tap stepped the quantity by 2 - 1, 3,
       5.

       The obvious guard, patching QuantitySelector.prototype.connectedCallback,
       CANNOT work: customElements.define() reads the lifecycle callbacks off
       the prototype once, at definition time, and stores them in the element
       definition. theme.js defines quantity-selector long before this file
       runs, so a later prototype change is simply never consulted. (An earlier
       version of this file did exactly that and silently did nothing.)

       So the buttons are rebuilt instead. A clone carries no listeners, and
       re-running the element's own plusListener/minusListener binds exactly
       one. The <input> is deliberately left alone - bundleSelector.js and
       loop-custom-logics.js both hold references to that node and observe it,
       so replacing it would break the bundle price and the Loop refresh. */
    function resetQuantityButtons() {
      mainForm.querySelectorAll("quantity-selector").forEach(el => {
        ["minus", "plus"].forEach(part => {
          const btn = el.querySelector(".quantity-selector--" + part);
          if (btn) btn.replaceWith(btn.cloneNode(true));
        });

        // connectedCallback cached the old nodes
        el.minus = el.querySelector(".quantity-selector--minus");
        el.plus = el.querySelector(".quantity-selector--plus");

        if (typeof el.plusListener === "function") el.plusListener();
        if (typeof el.minusListener === "function") el.minusListener();
      });
    }

    /* Every move re-runs connectedCallback on everything inside the form, and
       the theme's elements bind listeners there without unbinding - so moving
       the form on each open AND close stacked handlers until one "+" tap
       stepped the quantity by six. The form is therefore borrowed once and
       left in the drawer: the collapsed bar hides it, and only a switch to
       desktop hands it back - collapsing just hides it in place. */
    function borrowProductForm() {
      if (!borrowsForm) return;

      if (!widgetHost.contains(mainForm)) {
        widgetHost.appendChild(mainForm);
        resetQuantityButtons();   // the move just bound a second set
      }

      widgetHost.style.display = "";
    }

    function returnProductForm() {
      if (!borrowsForm || !widgetHost.contains(mainForm)) return;

      formOrigin.parent.insertBefore(mainForm, formOrigin.next);
      resetQuantityButtons();   // moving back re-binds too
      widgetHost.style.display = "none";
    }

    // the collapsed header mirrors whichever option the widget has selected
    function updateHeaderPrice() {
      if (!borrowsForm) return;

      const selected = loopContainer?.querySelector(".loop-widget-purchase-option-selected")
        || subOption || oneTimeOption;
      const price = selected && selected.querySelector(".loop-widget-purchase-option-price-container");

      if (price) priceDisplay.innerHTML = price.innerHTML;
    }

    if (borrowsForm) {
      updateHeaderPrice();
      window.addEventListener("bundle:update", updateHeaderPrice);
    }

    if(productBannerEL) {
      freegift.innerHTML = productBannerEL.outerHTML;
      freegift.style.display = "";
    }
    

    if (isOutOfStock) return;


    /* -------------------------------
      MOBILE PRODUCT MEDIA SWITCHER
    --------------------------------*/
    const mobileMainGallery = document.querySelector('.main-product--mobile:not([data-type="optional"])');
    const mobileOptionalGallery = document.querySelector('.main-product--mobile[data-type="optional"]');

    const hasMobileOptional = mobileOptionalGallery !== null;

    function updateMobileGallery(mode) {
      
      if (!hasMobileOptional) return;   // do nothing if optional gallery missing
      
      if (productType !== "Starter Bundle") return;

      // absent on the borrowed-form drawer, which has no mode buttons
      if (subBtn) subBtn.textContent = "Subscribe • Save 33%";

      if (mode=='subscribe') {
        // Subscription selected → show main, hide optional
        /*
        if (mobileMainGallery) mobileMainGallery.style.display = "";
        mobileOptionalGallery.style.display = "none";
        */

        mobileMainGallery.style.display = "none";
        mobileOptionalGallery.style.display = "";

        //show free gift. hide terms
        freegift.style.display = "";
        drawerBadge.style.display = "inline-block";
        actionTerms.style.display = "none";
        drawerImage.style.display = "none";
        drawerImageOpt.style.display = "";

        const subPriceOrg = drawer.querySelector(".loop-widget-purchase-option-price");
        const subPriceComp = drawer.querySelector(".loop-widget-purchase-option-compare-at-price");

        subPriceComp.textContent = "$42.00";

      } else if(mode == 'onetime') {
        // One-time selected → show optional, hide main
        /*
        if (mobileMainGallery) mobileMainGallery.style.display = "none";
        mobileOptionalGallery.style.display = "";
        */
        mobileMainGallery.style.display = "";
        mobileOptionalGallery.style.display = "none";

        //hide free gift. show terms
        freegift.style.display = "none";
        drawerBadge.style.display = "none";
        actionTerms.style.display = "";

        drawerImage.style.display = "";
        drawerImageOpt.style.display = "none";

        const oneTimePriceOrg = drawer.querySelector(".product-price--original");
        const oneTimePriceComp = drawer.querySelector(".product-price--compare");
        oneTimePriceComp.style.display = "none"
  
      } else {
        //default

      }
    }

    // Run once
    updateMobileGallery();

    // --- State ---
    let activeMode = null;
    let minQty = 1;

    // --- Helpers ---
    const updateQty = (val) => {
      val = Math.max(minQty, parseInt(val, 10));
      qtyInput.value = val;
      if (realQty) realQty.value = val;
    };

    const showToast = (msg) => {
      const toast = document.createElement("div");
      toast.className = "drawer-toast";
      toast.textContent = msg;
      document.body.appendChild(toast);
      setTimeout(() => toast.remove(), 2000);
    };

    const expandDrawer = (mode) => {
      drawer.classList.add("expanded");
      drawer.classList.remove("collapsed");
      overlay.classList.add("visible");
      document.body.classList.add("no-scroll");

      // the borrowed form is the whole expanded view - no mode, no cloned copy
      if (borrowsForm) {
        borrowProductForm();
        updateHeaderPrice();
        window.dispatchEvent(new CustomEvent('bundle:update'));
        return;
      }

      features.innerHTML =
        mode === "subscribe" ? subDesc || "" : oneTimeDesc || "";

      priceDisplay.innerHTML =
        mode === "subscribe" ? subPrice?.innerHTML || "" : oneTimePrice?.outerHTML || "";

      oneTimeBtn.classList.toggle("active", mode === "onetime");
      subBtn.classList.toggle("active", mode === "subscribe");

      // Surface Loop's real frequency selector only in the subscribe view.
      // Re-query in case Loop re-rendered and replaced the cached node.
      if (!freqSelector || !freqSelector.isConnected) {
        freqSelector = subOption ? subOption.querySelector(".loop-widget-spg-container") : null;
      }
      if (mode === "subscribe" && freqSelector) {
        freqContainer.appendChild(freqSelector);   // moves the live node
        freqContainer.style.display = "";
      } else {
        if (freqSelector && freqOriginalParent) freqOriginalParent.appendChild(freqSelector);
        freqContainer.style.display = "none";
      }

      window.dispatchEvent(new CustomEvent('bundle:update'));
    };

    const collapseDrawer = () => {
      drawer.classList.add("collapsed");
      drawer.classList.remove("expanded");
      overlay.classList.remove("visible");
      document.body.classList.remove("no-scroll");

      features.innerHTML = "";

      if (borrowsForm) {
        widgetHost.style.display = "none";
        updateHeaderPrice();
        return;
      }

      // Return Loop's frequency selector to its widget so Loop's DOM stays intact.
      if (freqSelector && freqOriginalParent && freqContainer.contains(freqSelector)) {
        freqOriginalParent.appendChild(freqSelector);
      }
      freqContainer.style.display = "none";
      priceDisplay.innerHTML = oneTimePrice?.outerHTML || "";
      oneTimeBtn?.classList.remove("active");
      subBtn?.classList.remove("active");
      activeMode = null;
      minQty = 1;
    };

    // --- Quantity control ---
    plusBtn.addEventListener("click", () => updateQty(parseInt(qtyInput.value) + 1));
    minusBtn.addEventListener("click", () => updateQty(parseInt(qtyInput.value) - 1));

    // --- Button logic ---
    const handleBuyClick = (mode) => {
      minQty = mode === "subscribe" && productType === "Single" ? 5 : 1;

      // First click: expand + enforce min qty
      if (!drawer.classList.contains("expanded")) {
        if (mode === "subscribe" && parseInt(qtyInput.value, 10) < minQty) {
          updateQty(minQty);
        }
        expandDrawer(mode);
        activeMode = mode;
        updateMobileGallery(mode);
        return;
      }

      // Switching mode after expanded
      if (activeMode !== mode) {
        if (mode === "subscribe" && parseInt(qtyInput.value, 10) < minQty) {
          updateQty(minQty);
        }
        expandDrawer(mode);
        activeMode = mode;
        updateMobileGallery(mode);
        return;
      }

      // ✅ Trigger Loop option click
      if (mode === "subscribe" && subOption) subOption.click();
      else if (mode === "onetime" && oneTimeOption) oneTimeOption.click();

      

      // Delay for Loop to process
      setTimeout(() => {
        realSubmit.click();
        collapseDrawer();
        const successText = `adding to cart...`;
        priceDisplay.innerHTML = successText;
        actionWrapper.style.display = "none";
        actionTerms.style.display = "none";
      }, 100);

      setTimeout(() => {
        collapseDrawer();
        actionWrapper.style.display = "flex";
      }, 2000)
      
      
      
    };

    oneTimeBtn?.addEventListener("click", () => handleBuyClick("onetime"));
    subBtn?.addEventListener("click", () => handleBuyClick("subscribe"));
    drawer.querySelector(".shopnow")?.addEventListener("click", () => expandDrawer());
    closeBtn.addEventListener("click", collapseDrawer);
    overlay.addEventListener("click", collapseDrawer);


    // --- Responsive check ---
    const toggleDrawerVisibility = () => {
      const isMobile = window.innerWidth <= 767;
      drawer.style.display = isMobile ? "block" : "none";

      // the drawer is hidden above 767px, so a borrowed form has to go back or
      // the desktop page is left without one
      if (!isMobile) {
        collapseDrawer();
        returnProductForm();
      }
    };
    toggleDrawerVisibility();
    window.addEventListener("resize", toggleDrawerVisibility);
  });
});